module.exports = __webpack_public_path__ + "img/bottom-border.7207b37c.png";